module.exports = __webpack_public_path__ + "0bd152fd37994f0dc6df3d18c105cd1c.png";